import {Baklava, Kebab, Fish, Spaghetti} from "../components/Assets";

export const data = [
    {
        id: 1,
        title: 'Kebab',
        desc: "Ram kebab",
        price: '9.25',
        imgSrc: Kebab
    },

    {   
        id: 2,
        title: 'Baklava',
        desc: "Pistachio Baklava",
        price: '15.65',
        imgSrc: Baklava
    },

    {
        id: 3,
        title: 'Tilapia',
        desc: "Roasted Tilapia",
        price: '10.25',
        imgSrc: Fish
    },

    {
        id: 4,
        title: 'Spaghetti',
        desc: "Spaghetti Bolognese",
        price: '12.25',
        imgSrc: Spaghetti
    },
]
